import { submissionCardsFields, submissionFields } from '../../../../airtable/metadata/submissions';
import { formatCurrency } from '../../../../commons/utils';
import { createColumn } from '../../../components/dynamic-table';
import { editComponentDefault } from '../../common/utils';

export function createColumns() {
  return [
    createColumn('quantity', {
      initialEditValue: 1,
      invalidTest: value => typeof value !== 'number' || value <= 0,
      invalidText: 'must be at least 1',
      title: 'Quantity (duplicates)',
      type: 'numeric',
      editComponent: props => {
        const { columnDef, onChange } = props;

        const customOnChange = quantity => {
          onChange(Math.max(quantity, columnDef.initialEditValue));
        };

        return editComponentDefault({ ...props, onChange: customOnChange });
      },
    }),
    createColumn(submissionCardsFields.YEAR, {
      invalidTest: value => typeof value !== 'number' || value <= 1850 || value > 2030,
      invalidText: 'must be between 1850 and 2030',
      type: 'numeric',
    }),
    createColumn(submissionCardsFields.CARD_NAME, {
      invalidTest: value => typeof value !== 'string' || value.length <= 0,
      invalidText: 'is required',
      title: 'Player',
      type: 'string',
    }),
    createColumn(submissionCardsFields.SET, {
      invalidTest: value => typeof value !== 'string' || value.length <= 0,
      invalidText: 'is required',
      type: 'string',
    }),
    createColumn(submissionCardsFields.CARD_NUMBER, {
      invalidTest: value => typeof value !== 'string' || value.length <= 0,
      invalidText: 'is required',
      type: 'string',
    }),

    // createColumn('dciReview', {
    //   title: 'DCI Review',
    //   type: 'boolean',
    //   editComponent: props => {
    //     const { onRowDataChange, rowData = {} } = props;
    //
    //     const customOnChange = dciReview => {
    //       onRowDataChange({ ...rowData, dciReview, [submissionCardsFields.PREP]: !dciReview });
    //     };
    //
    //     return editComponentDefault({ ...props, onChange: customOnChange });
    //   },
    // }),

    createColumn('dciReview', {
      editable: 'never',
      initialEditValue: true,
      title: 'DCI Review',
      type: 'boolean',
    }),

    // createColumn(submissionCardsFields.DESTINATION, {
    //   invalidTest: (value, row) => {
    //     return (typeof value !== 'string' || value.length <= 0)
    //       && row.dciReview !== true;
    //   },
    //   invalidText: 'is required',
    //   lookup: destinations,
    //   render: (rowData = {}) => {
    //     const value = rowData[submissionCardsFields.DESTINATION];
    //
    //     if (value) {
    //       return value;
    //     }
    //
    //     return <Remove />;
    //   },
    //   editComponent: props => {
    //     const { columnDef, onChange, rowData = {}, value } = props;
    //
    //     if (rowData.dciReview === true) {
    //       if (value !== columnDef.initialEditValue) {
    //         onChange(columnDef.initialEditValue);
    //       }
    //       return <Remove />;
    //     }
    //
    //     return editComponentDefault(props);
    //   },
    // }),
    //
    // createColumn(submissionCardsFields.SERVICE_LEVEL, {
    //   invalidTest: (value, row) => {
    //     return (typeof value !== 'string' || value.length <= 0)
    //       && row.dciReview !== true;
    //   },
    //   invalidText: 'is required',
    //   lookup: serviceLevels,
    //   render: rowData => {
    //     return renderValueOrRemoveIcon(rowData, submissionCardsFields.SERVICE_LEVEL);
    //   },
    //   editComponent: props => {
    //     const { columnDef, onChange, rowData = {}, value } = props;
    //
    //     if (rowData.dciReview === true) {
    //       if (value !== columnDef.initialEditValue) {
    //         onChange(columnDef.initialEditValue);
    //       }
    //       return <Remove />;
    //     }
    //
    //     return editLookupBasedOnParentLookup(props, submissionCardsFields.DESTINATION);
    //   },
    // }),
    //
    // createColumn(submissionCardsFields.DECLARED_VALUE, {
    //   currencySetting: {
    //     maximumFractionDigits: 0,
    //     minimumFractionDigits: 0,
    //   },
    //   initialEditValue: 0,
    //   invalidTest: value => typeof value !== 'number' || value < 0,
    //   invalidText: 'cannot be negative',
    //   type: 'currency',
    //   editComponent: props => {
    //     const { columnDef, onChange, rowData = {}, value } = props;
    //
    //     if (rowData.dciReview === true) {
    //       if (value !== columnDef.initialEditValue) {
    //         onChange(columnDef.initialEditValue);
    //       }
    //       return <Remove />;
    //     }
    //
    //     const customOnChange = value => {
    //       onChange(value > 0 ? Math.trunc(value) : 0);
    //     };
    //
    //     return editComponentDefault({ ...props, onChange: customOnChange });
    //   },
    // }),

    createColumn(submissionCardsFields.DECLARED_VALUE, {
      currencySetting: {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      },
      initialEditValue: 0,
      invalidTest: value => typeof value !== 'number' || value < 0,
      invalidText: 'cannot be negative',
      type: 'currency',
      editComponent: props => {
        const { columnDef, onChange } = props;

        const customOnChange = quantity => {
          onChange(Math.max(quantity, columnDef.initialEditValue));
        };

        return editComponentDefault({ ...props, onChange: customOnChange });
      },
    }),

    createColumn(submissionCardsFields.HARD_CASE, {
      initialEditValue: false,
      type: 'boolean',
    }),

    // createColumn(submissionCardsFields.PREP, {
    //   initialEditValue: true,
    //   type: 'boolean',
    //   editComponent: props => {
    //     const { rowData = {} } = props;
    //
    //     if (rowData.dciReview === true) {
    //       return <Remove />;
    //     }
    //
    //     return editComponentDefault(props);
    //   },
    // }),
  ];
}

export function createCommonSubmissionsTableColumns() {
  return [
    createColumn(submissionFields.SUBMISSION_NUMBER, { type: 'numeric', emptyValue: 'No order number' }),
    createColumn(submissionFields.DATE_SENT, { type: 'date' }),
    createColumn(submissionFields.TRACKING_NUMBER, { type: 'string' }),
    createColumn(submissionFields.CARDS_SENT, { type: 'numeric' }),
    createColumn('Total', {
      render: submission => formatCurrency(submission.total),
      type: 'numeric',
    }),
  ];
}

export function createCommonSubmissionCardsTableColumns() {
  return [
    createColumn(submissionCardsFields.YEAR, { type: 'numeric' }),
    createColumn(submissionCardsFields.CARD_NAME, { type: 'string', title: 'Player' }),
    createColumn(submissionCardsFields.SET, { type: 'string' }),
    createColumn(submissionCardsFields.CARD_NUMBER, { type: 'string' }),
    createColumn(submissionCardsFields.DESTINATION, { type: 'string' }),
    createColumn(submissionCardsFields.DECLARED_VALUE, {
      render: card => formatCurrency(card.fields[submissionCardsFields.DECLARED_VALUE]),
      type: 'numeric',
    }),
    createColumn(submissionCardsFields.HARD_CASE, {
      render: card => card.fields[submissionCardsFields.HARD_CASE] === true ? 'Yes' : 'No',
      type: 'boolean',
    }),

    // createColumn(submissionCardsFields.PREP, {
    //   render: card => {
    //     return <Checkbox disabled checked={card.fields[submissionCardsFields.PREP]} />;
    //   },
    // }),
    // createColumn(submissionCardsFields.SERVICE_LEVEL, { type: 'string' }),
  ];
}
